export default __webpack_public_path__ + "static/media/Green-check.c82feb15.svg";